import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useQuickChecksStore = defineStore('quickChecks', {
  state,
  getters,
  actions
})

export default useQuickChecksStore
